<template>
  <div class="chart">
    <div ref="lineChart" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "pieChartView",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "canvas",
    },
  },

  data() {
    return {
      chart: null,
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
  },
  mounted() {
    this.initChart();
    if (this.autoResize) {
      window.addEventListener("resize", this.resizeHandler);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.resizeHandler);
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeHandler() {
      this.chart.resize();
    },
    initChart() {
      this.chart = echarts.init(this.$refs.lineChart, "", {
        renderer: this.type,
      });
      this.initChartOption();
      this.chart.on("click", this.handleClick);
    },
    initChartOption() {
      const _this = this;
      const color = [
        "#00baff",
        "#ff00c9",
        "#4cca73",
        "#f7a82b",
        "#ff9999",
        "#993333",
        "#ccff00",
      ];
      const title = {
        name: "总数",
        value: _this.data.totalCount,
        unit: "只",
      };
      const rich = {
        name: {
          color: "#DEDEDE",
          fontSize: 14,
          align: "left",
          padding: [0, 10, 20, 0],
        },
        value: {
          color: "#ccc",
          fontSize: 14,
          align: "left",
        },
        // 总数标题
        title: {
          color: "#fff",
          fontSize: 14,
          padding: [10, 0, 0, 0],
        },
        titleUnit: {
          color: "#fff",
          fontSize: 14,
          padding: [15, 0, 0, 0],
        },
        titleValue: {
          color: "#fff",
          fontSize: 14,
          fontWeight: 600,
          padding: [5, 5, 5, 5],
        },
      };
      this.chart.setOption({
        color,
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          formatter: function (parms) {
            var str =
              "" +
              parms.marker +
              "" +
              parms.data.name +
              "：" +
              (parms.data.value ? `${parms.data.value}只` : "--");
            return str;
          },
        },
        legend: {
          orient: "vertical",
          icon: "rect",
          x: "70%",
          y: "20%",
          itemWidth: 14,
          itemHeight: 2,
          itemGap: 30,
          width: "263px",
          align: "left",
          textStyle: {
            color: "#D7E5FF",
            fontSize: 14,
            rich,
          },
          formatter: function (name) {
            let res = _this.data.keyValues.filter((v) => v.name === name);
            let str = "";
            str = "{name1|" + res[0].name + "}";
            return str;
          },
        },
        // grid: {
        //   top: "15%",
        //   left: "20%",
        //   right: "10%",
        //   bottom: "0%",
        //   containLabel: true,
        // },
        series: [
          {
            type: "pie",
            center: ["35%", "55%"],
            radius: ["70%", "80%"],
            data: _this.data.keyValues,
            startAngle: 180,
            label: {
              show: false,
            },
          },
          {
            type: "pie",
            center: ["35%", "55%"],
            radius: ["70%", "80%"],
            data: _this.data.keyValues,
            startAngle: 180,
            label: {
              show: true,
              position: "center",
              formatter: () =>
                `{title|${title.name}}\n{titleValue|${title.value}}`,
              rich,
            },
            itemStyle: {
              borderColor: "#082545",
              borderWidth: 2,
            },
          },
        ],
      });
    },
    handleClick(params) {
      this.$emit("click", params);
    },
    setOptions() {
      this.clearChart();
      this.resizeHandler();
      if (this.chart) {
        this.initChartOption();
      }
    },
    refresh() {
      this.initChartOption();
    },
    clearChart() {
      this.chart && this.chart.clear();
    },
  },
};
</script>